// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gallery-page {
  width: 100%;
  padding-top: 0px;
  min-height: calc(100vh - 80px);
  background-color: black;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.gallery-hero {
  position: relative;
  height: 80vh;
  min-height: 400px;
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
}

.video-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.video-background video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  margin: 0;
  padding: 0;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0.85)
  );
  margin: 0;
  padding: 0;
}

.gallery-hero-content {
  position: relative;
  z-index: 2;
  color: white;
  text-align: center;
  max-width: 1000px;
  padding: 0 2rem;
  margin: 0;
}

.gallery-hero-content h1 {
  font-family: 'Josefin Sans', sans-serif;
  font-size: 3.5rem;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  color: #D4AF37;
}

.gallery-hero-content p {
  font-size: 1.25rem;
  line-height: 1.6;
  margin-bottom: 3rem;
  opacity: 0.9;
}

.gallery-stats {
  display: flex;
  justify-content: center;
  gap: 4rem;
  margin-top: 2rem;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stat-number {
  font-family: 'Josefin Sans', sans-serif;
  font-size: 2.5rem;
  font-weight: bold;
  color: #D4AF37;
  margin-bottom: 0.5rem;
}

.stat-label {
  font-size: 1rem;
  opacity: 0.9;
  text-transform: uppercase;
  letter-spacing: 1px;
}

@media (max-width: 768px) {
  .gallery-hero {
    height: 60vh;
    min-height: 350px;
  }

  .gallery-hero-content h1 {
    font-size: 2.5rem;
  }

  .gallery-hero-content p {
    font-size: 1.1rem;
  }

  .gallery-stats {
    gap: 2rem;
    flex-wrap: wrap;
  }

  .stat-number {
    font-size: 2rem;
  }
}

@media (max-width: 480px) {
  .gallery-hero {
    height: 50vh;
    min-height: 300px;
  }

  .gallery-hero-content h1 {
    font-size: 2rem;
  }

  .gallery-stats {
    gap: 1.5rem;
  }

  .stat-number {
    font-size: 1.75rem;
  }
}

.gallery-board {
  padding: 4rem 2rem;
  background-color: white;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.gallery-item {
  position: relative;
  aspect-ratio: 1;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.gallery-item:hover {
  transform: scale(1.02);
}

.gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  transition: transform 0.3s ease;
}

.gallery-item:hover img {
  transform: scale(1.1);
}

.gallery-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 2rem;
}

.modal-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
}

.modal-content img {
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 8px;
}

.close-button {
  position: absolute;
  top: -40px;
  right: -40px;
  background: none;
  border: none;
  color: white;
  font-size: 2rem;
  cursor: pointer;
  padding: 0.5rem;
  line-height: 1;
}

@media (max-width: 768px) {
  .gallery-board {
    padding: 2rem 1rem;
  }

  .gallery-grid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 1rem;
  }

  .close-button {
    top: -30px;
    right: -10px;
  }
}

@media (max-width: 480px) {
  .gallery-grid {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/GalleryPage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;GAGC;EACD,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,UAAU;IACV,YAAY;EACd;AACF;;AAEA;EACE;IACE,4DAA4D;EAC9D;AACF","sourcesContent":[".gallery-page {\n  width: 100%;\n  padding-top: 0px;\n  min-height: calc(100vh - 80px);\n  background-color: black;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.gallery-hero {\n  position: relative;\n  height: 80vh;\n  min-height: 400px;\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  padding: 0;\n}\n\n.video-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n.video-background video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  margin: 0;\n  padding: 0;\n}\n\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    rgba(0, 0, 0, 0.5),\n    rgba(0, 0, 0, 0.85)\n  );\n  margin: 0;\n  padding: 0;\n}\n\n.gallery-hero-content {\n  position: relative;\n  z-index: 2;\n  color: white;\n  text-align: center;\n  max-width: 1000px;\n  padding: 0 2rem;\n  margin: 0;\n}\n\n.gallery-hero-content h1 {\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 3.5rem;\n  margin-bottom: 1.5rem;\n  line-height: 1.2;\n  color: #D4AF37;\n}\n\n.gallery-hero-content p {\n  font-size: 1.25rem;\n  line-height: 1.6;\n  margin-bottom: 3rem;\n  opacity: 0.9;\n}\n\n.gallery-stats {\n  display: flex;\n  justify-content: center;\n  gap: 4rem;\n  margin-top: 2rem;\n}\n\n.stat-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.stat-number {\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 2.5rem;\n  font-weight: bold;\n  color: #D4AF37;\n  margin-bottom: 0.5rem;\n}\n\n.stat-label {\n  font-size: 1rem;\n  opacity: 0.9;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n@media (max-width: 768px) {\n  .gallery-hero {\n    height: 60vh;\n    min-height: 350px;\n  }\n\n  .gallery-hero-content h1 {\n    font-size: 2.5rem;\n  }\n\n  .gallery-hero-content p {\n    font-size: 1.1rem;\n  }\n\n  .gallery-stats {\n    gap: 2rem;\n    flex-wrap: wrap;\n  }\n\n  .stat-number {\n    font-size: 2rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .gallery-hero {\n    height: 50vh;\n    min-height: 300px;\n  }\n\n  .gallery-hero-content h1 {\n    font-size: 2rem;\n  }\n\n  .gallery-stats {\n    gap: 1.5rem;\n  }\n\n  .stat-number {\n    font-size: 1.75rem;\n  }\n}\n\n.gallery-board {\n  padding: 4rem 2rem;\n  background-color: white;\n}\n\n.gallery-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.gallery-item {\n  position: relative;\n  aspect-ratio: 1;\n  border-radius: 12px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n}\n\n.gallery-item:hover {\n  transform: scale(1.02);\n}\n\n.gallery-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 12px;\n  transition: transform 0.3s ease;\n}\n\n.gallery-item:hover img {\n  transform: scale(1.1);\n}\n\n.gallery-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.9);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 2rem;\n}\n\n.modal-content {\n  position: relative;\n  max-width: 90vw;\n  max-height: 90vh;\n}\n\n.modal-content img {\n  max-width: 100%;\n  max-height: 90vh;\n  object-fit: contain;\n  border-radius: 8px;\n}\n\n.close-button {\n  position: absolute;\n  top: -40px;\n  right: -40px;\n  background: none;\n  border: none;\n  color: white;\n  font-size: 2rem;\n  cursor: pointer;\n  padding: 0.5rem;\n  line-height: 1;\n}\n\n@media (max-width: 768px) {\n  .gallery-board {\n    padding: 2rem 1rem;\n  }\n\n  .gallery-grid {\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n    gap: 1rem;\n  }\n\n  .close-button {\n    top: -30px;\n    right: -10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .gallery-grid {\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
